import { useLazyComment } from "@/hooks/useComment";
import dynamic from "next/dynamic";
import styles from "./styles.module.less";

const Editor = dynamic(
  () => import("../../../../../Comment/components/Editor"),
  { ssr: false }
);

interface IProps {
  fatherId: string;
  scope?: string;
  url: string;
}

export const AddComment: React.FC<IProps> = ({ fatherId, url }) => {
  const { refetch } = useLazyComment(fatherId, "user");
  const { addComment, loadingAdd } = useLazyComment(fatherId, "all");

  const handleSubmit = async (props: {
    fatherId: string;
    content: string;
    response: string;
    parentId?: string;
    url?: string;
  }) => {
    await addComment({ ...props });
    await refetch();
  };

  return (
    <div className={styles.content}>
      <Editor
        fatherId={fatherId}
        submitting={loadingAdd}
        handleSubmit={handleSubmit}
        url={url}
      />
    </div>
  );
};

export default AddComment;
